const buildingCardSwiper = new Swiper(".building_swiper", {
  direction: "horizontal",
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 1,
  spaceBetween: 15,

  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    type: "fraction", // 枚数表示
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  watchSlidesProgress: true,

  scrollbar: {
    el: ".swiper-scrollbar",
  },

  breakpoints: {
    601: {
      slidesPerView: 2,
      spaceBetween: 25,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 45,
    },
  },
});

const max = 5;
for (let i = 1; i < max; i++) {
  const myString = ".link_swiper.is-" + i;
  const mySwiperSimple = document.querySelector(myString);
  if (mySwiperSimple) {
    const swiper = new Swiper(mySwiperSimple, {
      direction: "horizontal",
      slidesPerView: 2,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      watchSlidesProgress: true,
      breakpoints: {
        601: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
  }
}
